
import { Component, OnInit } from '@angular/core';
import { ShopService } from '../../../services/shop.service';


@Component({
  selector: 'app-list-shops',
  templateUrl: './list-shops.component.html',
  styleUrls: ['./list-shops.component.css'],
  providers:[ShopService]
})
export class ListShopsComponent implements OnInit {

  shops:any = [];

  constructor(private shopService:ShopService) { }

  ngOnInit() {
    this.getShops();
  }

  getShops(){
    this.shopService.query({})
      .subscribe((shops) => {
        this.shops = shops;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/shops/list-shops/list-shops.component.ts